export default {
	showLatest() {
		const newsVersion = localStorage.getItem("rec.news.version");

		if (newsVersion == $rec.newsVersion) // no type conversion as variables could be int or string
			return;

		const info = {
			content: $rec.newsSummary,
			onClose: () => {
				localStorage.setItem("rec.news.version", $rec.newsVersion);
			}
		};

		$bus.$emit("notify", "NotificationInfo", info);
	}
};
